import { Component } from '@angular/core';

@Component({
  selector: 'app-convert-pdf-to-excel-online',
  imports: [],
  templateUrl: './convert-pdf-to-excel-online.component.html',
  styleUrl: './convert-pdf-to-excel-online.component.css'
})
export class ConvertPdfToExcelOnlineComponent {

}
